import "./style.scss";
import * as React from "react";
import JSZip from "jszip";
import html2canvas from "html2canvas";
import { Flyer, FlyerItem } from "../../../../core/Chart/Heatmap/types";
import { Heatmap } from "../../../../core/Chart/Heatmap";

// Hack: Bypass typing issues
const htmlToCanvas = html2canvas as any;

interface HeatmapChartProps {
  flyer: Flyer;
  metric: string;
  items: FlyerItem[];
  id: string;
  fullscreen?: boolean;
  flyersLoading?: boolean;
  flyerItemsLoading?: boolean;
}

export interface HeatmapChart {
  heatmapPages: HTMLElement[];
}
export class HeatmapChart extends React.Component<HeatmapChartProps, any> {
  constructor() {
    super();
    this.heatmapPages = [];
  }

  // Higher order function to set heatmap page references
  // https://reactjs.org/docs/refs-and-the-dom.html
  setHeatmapPage = (index: number) => (el: any) =>
    (this.heatmapPages[index] = el);

  render() {
    const metric =
      this.props.metric == "item_views" ? "views" : this.props.metric;
    const height = this.props.fullscreen ? "calc(100% - 100px)" : 385;
    return (
      <div className="heatmap-wrapper" style={{ height: height }}>
        <Heatmap
          flyer={this.props.flyer}
          metric={metric}
          items={this.props.items}
          pageRef={this.setHeatmapPage}
          id={this.props.id}
          flyerItemsLoading={this.props.flyerItemsLoading}
          flyersLoading={this.props.flyersLoading}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/Visualizations/HeatmapChart/index.tsx